import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { AuthService } from '../core/auth.service';
import { UserService } from '../services/user.service';
import { AchooPopupComponent } from '../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../services/modal/modal.service';
import { FormBuilder } from '@angular/forms';
import { AppSettings } from '../utils/app-settings';
import { FeaturePermission } from '../../models/influencer/feature-permission';
import { InfluencerService } from '../services/influencer/influencer.service';
var InfluencerMainComponent = /** @class */ (function () {
    function InfluencerMainComponent(auth, router, formBuilder, modalService, userService, activatedRoute, influencerService) {
        this.auth = auth;
        this.router = router;
        this.formBuilder = formBuilder;
        this.modalService = modalService;
        this.userService = userService;
        this.activatedRoute = activatedRoute;
        this.influencerService = influencerService;
        this.isAcceptionTermAndCon = false;
        this.expandMobileMenu = false;
        this.isNewCampaign = false;
        this.featurePermission = new FeaturePermission(false, false);
    }
    InfluencerMainComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.initializeInfluencerConfirmationModal();
        // Make mobile close menu when route
        this.router
            .events
            .subscribe(function (event) {
            if (event instanceof NavigationStart) {
                _this.expandMobileMenu = false;
            }
        });
        this.featurePermissionSubscription = this.auth.influencerFeaturePermission.subscribe(function (permission) {
            if (permission) {
                _this.featurePermission = permission;
            }
        });
        this.activatedRoute.queryParams.subscribe(function (params) {
            _this.isNewCampaign = params.isNewCampaign;
        });
    };
    InfluencerMainComponent.prototype.initializeInfluencerConfirmationModal = function () {
        var _this = this;
        this.termsAndConditionSubscription = this.auth.termsAndConditionObserver.subscribe(function (res) {
            if (res) {
                _this.modalService.close();
            }
            else if (AppSettings.isActiveNewCampaignFlow()) {
                _this.modalService.openInCenter(_this.influencerConfirmation, _this.beforeDismissConfirmationPopup.bind(_this), 'infl-confirm-modal', true);
            }
            else {
                _this.modalService.openInCenter(_this.termsAndConditionAccept, _this.beforeDismissAcceptionTerm.bind(_this), 'term-accept-modal', true);
            }
        });
        this.newUser = this.formBuilder.group({
            acceptTermService: [null]
        });
        var currentInfluencer = this.userService.getInfluencerInfo();
        if (!this.auth.isAccessingLandingPage(this.router.url) && currentInfluencer && !currentInfluencer.acceptedTermService) {
            this.auth.needAcceptedTermAndCondition();
        }
    };
    InfluencerMainComponent.prototype.ngOnDestroy = function () {
        if (this.termsAndConditionSubscription) {
            this.termsAndConditionSubscription.unsubscribe();
        }
        if (this.featurePermissionSubscription) {
            this.featurePermissionSubscription.unsubscribe();
        }
    };
    InfluencerMainComponent.prototype.toggleMobileMenu = function () {
        this.expandMobileMenu = !this.expandMobileMenu;
    };
    InfluencerMainComponent.prototype.popperOnShown = function (e) {
        this.showFadedBg = true;
    };
    InfluencerMainComponent.prototype.popperOnHidden = function (e) {
        this.showFadedBg = false;
    };
    InfluencerMainComponent.prototype.beforeDismissAcceptionTerm = function () {
        var _this = this;
        setTimeout(function () {
            _this.modalService.openInCenter(_this.termsAndConditionAccept, _this.beforeDismissAcceptionTerm.bind(_this), 'term-accept-modal');
        }, 200);
    };
    InfluencerMainComponent.prototype.beforeDismissConfirmationPopup = function () {
        var _this = this;
        setTimeout(function () {
            _this.modalService.openInCenter(_this.influencerConfirmation, _this.beforeDismissConfirmationPopup.bind(_this), 'infl-confirm-modal');
        }, 200);
    };
    InfluencerMainComponent.prototype.logout = function () {
        this.auth.logout();
        this.userService.addInfluencerInfo(null);
        this.router.navigate(["/influencer/login"]);
        return false;
    };
    InfluencerMainComponent.prototype.acceptTermAndCondition = function (_a) {
        var _this = this;
        var value = _a.value, valid = _a.valid;
        var isAcceptTermService = value.acceptTermService;
        if (isAcceptTermService) {
            var user = this.auth.getUser();
            this.userService.acceptionTermAndCondition(user.data.id, 'user').subscribe(function (res) {
                _this.userService.updateAcceptTermAndService(true);
                _this.auth.haveAcceptedTermAndCondition();
                _this.auth.updateUser('user');
                _this.termsAndConditionSubscription.unsubscribe();
            });
        }
    };
    InfluencerMainComponent.prototype.onAcceptTheConfirmation = function () {
        this.modalService.close();
        this.userService.updateAcceptTermAndService(true);
        this.auth.haveAcceptedTermAndCondition();
        this.influencerService.confirmingInfluencerNameAndEmail();
        this.termsAndConditionSubscription.unsubscribe();
    };
    InfluencerMainComponent.prototype.onConfirmInfluencerInfoError = function () {
        this.initializeInfluencerConfirmationModal();
        this.influencerService.confirmedInfluencerNameAndEmail();
        this.modalService.openInCenter(this.influencerConfirmation, null, 'infl-confirm-modal', true);
    };
    Object.defineProperty(InfluencerMainComponent.prototype, "logoImage", {
        get: function () {
            return this.userService.logoImage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerMainComponent.prototype, "isDisableHomePage", {
        get: function () {
            return AppSettings.isDisableHomepage();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerMainComponent.prototype, "isDisableInboxPage", {
        get: function () {
            return !this.featurePermission.enableCommunication;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerMainComponent.prototype, "isDisableCampaignPage", {
        get: function () {
            return !this.featurePermission.enableCampaign;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerMainComponent.prototype, "userAvatarImage", {
        get: function () {
            var currentuser = this.userService.getInfluencerInfo();
            if (currentuser && currentuser.profilePicture) {
                return currentuser.profilePicture;
            }
            else {
                return 'assets/images/sidebar/default-user-avatar.png';
            }
        },
        enumerable: true,
        configurable: true
    });
    return InfluencerMainComponent;
}());
export { InfluencerMainComponent };



// WEBPACK FOOTER //
// ./src/app/influencer-main/influencer-main.component.ts.pre-build-optimizer.js